
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/spinner",
      function () {
        return require("private-next-pages/components/spinner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/spinner"])
      });
    }
  